// extracted by mini-css-extract-plugin
export default {"conversationNotice":"_6GoJ6MqvFCcvT6flCq32ef"};